import * as React from 'react';
import { Button, Card, CardBody, CardTitle, Grid, GridItem, Title } from '@patternfly/react-core';
import { decisions, decisionsText } from '../../../../shared/riskregister/decisions';
import type { Payload, Row, ViewState } from '../../../../shared/riskregister/types';

export const DecisionsPanel: React.FunctionComponent<{
  payload: Payload;
  rows: Row[];
  state: ViewState;
  onChange: (change: Partial<ViewState>) => void;
}> = ({ payload, rows, state, onChange }) => {
  const prompts = React.useMemo(() => decisions(rows, state, payload), [payload, rows, state]);
  const [copyStatus, setCopyStatus] = React.useState('');
  const view = state.area === 'ALL' ? 'all platform areas' : state.area;

  const copy = React.useCallback(async () => {
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(decisionsText(prompts, payload.as_of, view));
      setCopyStatus('Decision prompts copied as text.');
    } catch {
      setCopyStatus('Copy is unavailable in this browser.');
    }
  }, [payload.as_of, prompts, view]);

  return (
    <>
      <p>
        The backlog-growth prompt uses the same {state.win} trend window as Direction of risk.
        Area, accountability drill-down, and search apply; state filters do not.
      </p>
      <Button variant="secondary" onClick={() => void copy()}>Copy decisions as text</Button>
      <p aria-live="polite">{copyStatus}</p>
      <Grid hasGutter>
        {prompts.map((prompt) => (
          <GridItem key={prompt.id} span={12} md={6}>
            <Card isCompact>
              <CardTitle><Title headingLevel="h3" size="md">{prompt.title}</Title></CardTitle>
              <CardBody>
                <p><strong>Measured fact:</strong> {prompt.fact}</p>
                <p><strong>{prompt.ask}</strong></p>
                <p><strong>Accountable:</strong></p>
                {prompt.accountable.length ? (
                  <ul>{prompt.accountable.map((area) => <li key={area}>{area}</li>)}</ul>
                ) : (
                  <p>Clear: no accountable platform area requires a decision.</p>
                )}
                {prompt.walk && (
                  <Button variant="link" isInline onClick={() => onChange(prompt.walk as Partial<ViewState>)}>
                    Show these items in All items
                  </Button>
                )}
              </CardBody>
            </Card>
          </GridItem>
        ))}
      </Grid>
    </>
  );
};
